// New file created by srini on 02-04-25 for engagement section

const styles = theme => ({

    engText: {
        color: '#FFF ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    indicator: {
        backgroundColor: '#F3D45E ! important',
    },

    tabHead: {
        color: '#fff !important',
        textTransform: 'none !important',
        fontSize: '14px ! important',
        fontStyle: 'normal ! important',
        fontWeight: '400 !important',
        lineHeight: 'normal ! important',
    },

    customDataGrid: {
        '& .MuiDataGrid-columnHeaders': {
            color: '#999 !important',
            fontFamily: 'cardiuma-M !important',
            fontSize: '12px !important',
            lineHeight: '28px !important'
        },

        '& .MuiDataGrid-cell': {
            color: '#fff !important',
            fontFamily: 'cardiuma-regular !important',
            fontSize: '12px !important',
            fontWeight: '400 !important',
            borderBottom: '1.5px solid black !important',
        },

        "& .MuiDataGrid-menuIconButton": {
            opacity: 1,
            color: "#fff ! important"
        },

        "& .MuiDataGrid-sortIcon": {
            opacity: 1,
            color: "#fff ! important",
        },

        '& .MuiDataGrid-withBorderColor': {
            borderColor: "none !important"
        },

        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions': {
            color: '#fff !important',
            fontFamily: 'cardiuma-regular !important',
            fontSize: '12px  !important',
            fontWeight: '400  !important',
        },

        '& .MuiSelect-icon': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-footerContainer': {
            border: 'none ! important',
        },

        '& .MuiDataGrid-overlay': {
            backgroundColor: '#131E2E !important',
            color: '#fff !important',
            fontFamily: 'cardiuma-regular !important',
            fontSize: '12px  !important',
            fontWeight: '400  !important',
        },

        // '& .MuiSvgIcon-root': {
        //     color: '#fff ! important',
        // },

        '& .MuiDataGrid-filterIcon': {
            color: '#fff ! important',
        }
    },

    horizantalTablayout: {
        width: '99% ! important',
        height: 'auto',
        flexShrink: 0,
        borderRadius: '10px',
        background: '#131E2E',
        overflowY: 'auto'
    },


    uploadGrid: {
        display: 'flex !important',
        alignItems: 'center !important',
        marginLeft: '20px !important'
    },

    uploadSubGrid: {
        display: 'flex !important',
        flexDirection: 'column !important',
    },

    chooseButton: {
        backgroundColor: 'rgb(244, 71, 72) !important',
        padding: '9px 15px 9px 15px !important',
        fontSize: '12px !important'
    },

    sendbutton: {
        margin: '0px 0px 0px 20px',
    },

    button: {
        gap: "2px !important",
        color: "rgb(255, 255, 255) !important",
        backgroundColor: "rgb(244, 71, 72) !important",
        fontFamily: "cardiuma-regular !important",
        fontSize: "12px !important",
        fontStyle: "normal !important",
        BorderRadius: '4px !important',
        padding: '9px 15px 9px 15px !important',
    },

    disabledButton: {
        color: "#ffffff !important",
        backgroundColor: "#999999 !important",
        fontFamily: "cardiuma-regular !important",
        fontSize: "12px !important",
        fontStyle: "normal !important",
        BorderRadius: '4px !important',
        padding: '9px 15px 9px 15px !important',

    },

    previewText: {
        color: '#999999 !important',
        fontFamily: 'cardiuma-M !important'
    },

    cllIcnClr:{
        color: '#7DAA1C !important',
        '& .MuiSvgIcon-root': {
            color: '#7DAA1C !important',
        }
    },

    lcFrmDtFld: {
        display: 'flex',
        marginTop: '20px',
        marginBottom: '10px'
    },

    dtPkrWpr: {
        marginLeft: '15px'
    },

    dtPckr: {
        width: '190px',
        backgroundColor: '#131E2E ! important',

        '& .MuiInputBase-root': {
            color: '#fff ! important',
            height: '40px',
            padding: '6px 10px',
        },
        '& .MuiInputLabel-root': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular',
            fontSize: '14px',
            fontStyle: 'normal',
        },
        '& .MuiSvgIcon-root': {
            color: '#fff ! important',
        },

        "@media only screen and (max-width: 1620px)": {
            width: '190px !important'
        },
        "@media only screen and (max-width: 1420px)": {
            width: '180px !important'
        },
        "@media only screen and (max-width: 1350px)": {
            width: '170px !important'
        },
    },

    sbtBtn: {
        width: '100px !important',
        height: '38px !important',
        margin: '2px 0 10px 12px !important',
        color: '#fff !important',
        backgroundColor: '#F44748 !important',
        fontFamily: 'cardiuma-regular !important',
        fontSize: '12px !important',
    },

    errTxt: {
        fontFamily: 'cardiuma-regular !important',
        fontSize: '12px ! important',
        fontWeight: '400 ! important',
        lineHeight: '24px ! important',
        marginLeft: '5px !important'
    },

    modalStyle: {
        position: 'absolute',
        top: '40%',
        left: '55%',
        transform: 'translate(-50%, -50%)',
        background: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        minWidth: "400px",
        textAlign: "center"
    },

    subTxt: {
        fontFamily: 'cardiuma-M !important',
        fontSize: '20px ! important',
        fontWeight: '500 ! important',
        marginBottom: '15px !important'
    },

    subTtlTxt: {
        fontFamily: 'cardiuma-M !important',
        fontSize: '16px ! important',
        fontWeight: '500 ! important',
        marginBottom: '10px !important'
    },

    btnDwnCsv:{
        color: "#F3D45E !important",
        textDecoration: "underline !important",
        fontFamily: 'cardiuma-regular !important',
        fontSize: '13px !important',
        fontStyle: 'normal !important',
        fontWeight: 'bold !important',
    }

})

export default styles